
import React, { Component, Fragment } from 'react';
import Input from 'Components/Input';
import Dropdown from 'Components/Dropdown';
import { ReactComponent as PlusIcon } from 'Icons/plus.svg';
import { ReactComponent as CloseIcon } from 'Icons/close-circle.svg';
import { ReactComponent as StopIcon } from 'Icons/stop.svg';
import Cx from 'classnames';

import PlacesAutoComplete from 'Components/PlacesAutoComplete';

import { LEGS_TYPES, TAT_UNITS, LEGS_TYPES_AIR, LEGS_TYPES_SEA } from 'Constants/commonConstants';
import { getUser } from 'Utils/storage';
import ConfirmationPopup from 'Components/ConfirmationPopup';

class LegDetails extends Component {
   constructor(props) {
      super(props);
      this.trip = props.trip;
      this.viewMode = props.viewMode;
      this.legs = this.trip.legs;
        const { rfq, rfqType } = this.props;
        if((this.legs || []).length > 0) {
        const isSea = ((rfq.rfqDetails || {}).serviceCategoryType === 1);
        const isLCL = ((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5);
        const chargableWeight = ((this.trip.cargoParticularList || []).reduce((sum, el) => sum += Number(el.chargableWeight || 0),0));
        (this.legs || []).forEach((leg, index) => {
            if(((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)) {
                this.legs[index].setBusinessVolumeUnit(this.trip.metricSystem === 1 ? (((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5) ? { value: 11, name: "Per Cubic Meter"} : { value: 2, name: "Kilograms (KGs)"}) : { value: 12, name: "Pounds"});
                this.legs[index].setBusinessVolumeValue(chargableWeight)
            } else if(isSea && (rfq.rfqDetails || {}).serviceType !== 5) {
                this.legs[index].setBusinessVolumeUnit({ value: 8, name: "Container Load" });
                this.legs[index].setBusinessVolumeValue((this.trip || {}).noOfContainers || 1);
            }
            (this.legs[index].multiModeHeadingCharges || []).forEach((hc, hcIndex) => {
                if(((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)) {
                    this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeValue =  (chargableWeight);
                    this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeUnit = this.trip.metricSystem === 1 ? (isLCL ? 11 : 2) : 12;
                    this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeUnitName = this.trip.metricSystem === 1 ? (isLCL ? "Per Cubic Meter" : "Kilograms (KGs)") : 'Pounds';
                } else if(isSea && (rfq.rfqDetails || {}).serviceType !== 5) {
                    this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeValue = (this.trip || {}).noOfContainers || 1;
                    this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeUnit = 8;
                    this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeUnitName = "Container Load";
                }
            })
        })
        }
      this.state = {
         trip: props.trip,
         legs: this.trip.legs,
         isConfirmPopUp: false,
      }
   }

   UNSAFE_componentWillReceiveProps (nextProps) {
      if(nextProps.isChangelegValue) {
         const { rfq, rfqType } = this.props;
         if((this.legs || []).length > 0) {
            const isSea = ((rfq.rfqDetails || {}).serviceCategoryType === 1);
            const isLCL = ((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5);
            const chargableWeight = ((this.trip.cargoParticularList || []).reduce((sum, el) => sum += Number(el.chargableWeight || 0),0));
            (this.legs || []).forEach((leg, index) => {
                if(((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)) {
                    this.legs[index].setBusinessVolumeUnit(this.trip.metricSystem === 1 ? (((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5) ? { value: 11, name: "Per Cubic Meter"} : { value: 2, name: "Kilograms (KGs)"}) : { value: 12, name: "Pounds"});
                    this.legs[index].setBusinessVolumeValue(chargableWeight)
                } else if(isSea && (rfq.rfqDetails || {}).serviceType !== 5) {
                    this.legs[index].setBusinessVolumeUnit({ value: 8, name: "Container Load" });
                    this.legs[index].setBusinessVolumeValue((this.trip || {}).noOfContainers || 1);
                }
                (this.legs[index].multiModeHeadingCharges || []).forEach((hc, hcIndex) => {
                    if(((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)) {
                        this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeValue =  (chargableWeight);
                        this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeUnit = this.trip.metricSystem === 1 ? (isLCL ? 11 : 2) : 12;
                        this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeUnitName = this.trip.metricSystem === 1 ? (isLCL ? "Per Cubic Meter" : "Kilograms (KGs)") : 'Pounds';
                    } else if(isSea && (rfq.rfqDetails || {}).serviceType !== 5) {
                        this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeValue = (this.trip || {}).noOfContainers || 1;
                        this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeUnit = 8;
                        this.legs[index].multiModeHeadingCharges[hcIndex].headingChargesBusinessVolumeUnitName = "Container Load";
                    }
                })
            })
         }
         this.setState({
            legs: this.legs
         });
         this.props.onChange();
      }
   }

   addNewHeadingCharge = (index, type) => {
      const { rfq } = this.props;
      if(type === 'add') {
         this.legs[index].addNewMultiModeHeadingCharge({
            headingChargesValue: '',
            headingChargesID: '',
            headingChargesUnit: '',
            headingChargesUnitName: '',
            headingChargesUnitSymbol: '',
            headingChargesDescription: '',
            headingChargesMr: '',
            headingChargesLpp: '',
            headingChargesBudget: '',
            headingChargesCp: ''
         }, this.props.rfqServiceType);
      }
      if(type !== 'add' && this.props.costHeadList.length > 0) {
         const isSea = ((rfq.rfqDetails || {}).serviceCategoryType === 1);
         const isLCL = ((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5);
         const chargableWeight = ((this.state.trip.cargoParticularList || []).reduce((sum, el) => sum += Number(el.chargableWeight || 0),0));
         if(((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)) {
            this.legs[index].setBusinessVolumeUnit(this.state.trip.metricSystem === 1 ? (((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5) ? { value: 11, name: "Per Cubic Meter"} : { value: 2, name: "Kilograms (KGs)"}) : { value: 12, name: "Pounds"});
            this.legs[index].setBusinessVolumeValue(chargableWeight)
         }
         // this.legs[index].multiModeHeadingCharges[0].headingChargesValue = 'Service Charges';
         // this.legs[index].multiModeHeadingCharges[0].isBaseFreight = true;
         
         (this.props.costHeadList || []).map(cost => (
            this.legs[index].addNewMultiModeHeadingCharge({
               headingChargesValue: cost.name,
               headingChargesID: cost.id,
               headingChargesUnit: '',
               headingChargesUnitName: '',
               headingChargesUnitSymbol: '',
               headingChargesDescription: '',
               headingChargesMr: '',
               headingChargesLpp: '',
               headingChargesBudget: '',
               headingChargesCp: '',
               headingChargesBusinessVolumeValue: isSea ? (isLCL ? chargableWeight : (this.state.trip || {}).noOfContainers || 1) : chargableWeight,
               headingChargesBusinessVolumeUnit: isSea ? (isLCL ? (this.state.trip.metricSystem === 1 ? 11 : 2) : 8) : (this.state.trip.metricSystem === 1 ? 2 : 12),
               headingChargesBusinessVolumeUnitName: isSea ? (isLCL ? (this.state.trip.metricSystem === 1 ? "Per Cubic Meter" : "Kilograms (KGs)") : "Container Load") : (this.state.trip.metricSystem === 1 ? "Kilograms (KGs)" : "Pounds"),
               isBaseFreight: cost.name === 'Service Charges' ? true : undefined
            }, this.props.rfqServiceType, true)
         ));
         if(((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)) {
            this.legs[index].multiModeHeadingCharges[0].headingChargesBusinessVolumeValue =  (chargableWeight);
            this.legs[index].multiModeHeadingCharges[0].headingChargesBusinessVolumeUnit = this.state.trip.metricSystem === 1 ? (isLCL ? 11 : 2) : 12;
            this.legs[index].multiModeHeadingCharges[0].headingChargesBusinessVolumeUnitName = this.state.trip.metricSystem === 1 ? (isLCL ? "Per Cubic Meter" : "Kilograms (KGs)") : 'Pounds';
         } else if(isSea && (rfq.rfqDetails || {}).serviceType !== 5) {
            this.legs[index].multiModeHeadingCharges[0].headingChargesBusinessVolumeValue =  (this.state.trip || {}).noOfContainers || 1;
            this.legs[index].multiModeHeadingCharges[0].headingChargesBusinessVolumeUnit = 8;
            this.legs[index].multiModeHeadingCharges[0].headingChargesBusinessVolumeUnitName = "Container Load";
         }
      } else if(true) {
         const isSea = ((rfq.rfqDetails || {}).serviceCategoryType === 1);
         const isLCL = ((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType === 5);
         const chargableWeight = ((this.state.trip.cargoParticularList || []).reduce((sum, el) => sum += Number(el.chargableWeight || 0),0));
         const costHeadIndex = this.legs[index].multiModeHeadingCharges.length - 1;
         if(((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)) {
            this.legs[index].multiModeHeadingCharges[costHeadIndex].headingChargesBusinessVolumeValue =  (chargableWeight);
            this.legs[index].multiModeHeadingCharges[costHeadIndex].headingChargesBusinessVolumeUnit = this.state.trip.metricSystem === 1 ? (isLCL ? 11 : 2) : 12;
            this.legs[index].multiModeHeadingCharges[costHeadIndex].headingChargesBusinessVolumeUnitName = this.state.trip.metricSystem === 1 ? (isLCL ? "Per Cubic Meter" : "Kilograms (KGs)") : 'Pounds';
         } else if(isSea && (rfq.rfqDetails || {}).serviceType !== 5) {
            this.legs[index].multiModeHeadingCharges[costHeadIndex].headingChargesBusinessVolumeValue =  (this.state.trip || {}).noOfContainers || 1;
            this.legs[index].multiModeHeadingCharges[costHeadIndex].headingChargesBusinessVolumeUnit = 8;
            this.legs[index].multiModeHeadingCharges[costHeadIndex].headingChargesBusinessVolumeUnitName = "Container Load";
         }
      }
      this.setState({
         legs: this.legs
      })
   }

   handleMrCharges = (e) => {
      if (this.viewMode) {
         return;
      }
      const { trip } = this.state;
      trip.headingChargesMr = e.target.value;
      this.trip.setHeadingChargesMr(e.target.value)
      this.setState({ 
         trip: this.trip
      });
      this.props.onChange();
   }

   handleLppCharges = (e) => {
      if (this.viewMode) {
         return;
      }
      const { trip } = this.state;
      trip.headingChargesLpp = e.target.value;
      this.trip.setHeadingChargesLpp(e.target.value)
      this.setState({ 
         trip: this.trip
      });
      this.props.onChange();
   }

   handleTotalBudget = (e) => {
      if (this.viewMode) {
         return;
      }
      const { trip } = this.state;
      trip.totalBudget = e.target.value;
      this.trip.setTotalBudget(e.target.value)
      this.setState({ 
         trip: this.trip
      });
      this.props.onChange();
   }

   selectBaseCurrency = (option) => {
      if (this.viewMode) {
         return;
      }
      const { trip } = this.state;
      trip['priceInBaseCurrency'] = option.currency_name;
      trip['priceInBaseCurrencyType'] = option.currency_type;
      trip['priceInBaseCurrencySymbol'] = option.currency_symbol;
        (this.legs || []).forEach((leg, legIndex) => {
        leg.selectCostType(option.currency_type, option.currency_name, option.currency_symbol);
        (leg.multiModeHeadingCharges || []).forEach((mHeadingCharges, mIndex) => {
            mHeadingCharges.headingChargesUnitName = option.currency_name;
            mHeadingCharges.headingChargesUnitSymbol = option.currency_symbol;
            mHeadingCharges.headingChargesUnit = option.currency_type;
        })
        });
        this.setState({
        legs: this.legs
        })
      this.trip.setTotalBudget(option);
      this.setState({ 
         trip: this.trip
      });
      this.props.onChange();
   }

   setFromLocation = (index, location) => {
      if (this.viewMode) {
         return;
      }
      this.legs[index].setFromLocation(location);
      this.setState({
         legs: this.legs
      })
      this.props.onChange();
   }

   setToLocation = (index, location) => {
      if (this.viewMode) {
         return;
      }
      this.legs[index].setToLocation(location);
      this.setState({
         legs: this.legs
      })
      this.props.onChange();

   }
   addLeg = () => {
        if (this.viewMode) {
            return;
        }
        this.props.trip.addLeg();
        const { rfq } = this.props;
        if(((rfq.rfqDetails || {}).serviceCategoryType === 1 ? (rfq.rfqDetails || {}).serviceType === 5 : true)) {
            const legIndex = (this.legs.length - 1);
            this.legs[legIndex].setBusinessVolumeUnit(this.state.trip.metricSystem ? { value: 2, name: "Kilograms (KGs)"} : {value: 12, name: "Pounds"});
            this.legs[legIndex].setBusinessVolumeValue((this.state.trip.cargoParticularList || []).reduce((sum, el) => sum + Number(el.chargableWeight || 0),0));
        } else {
            this.props.trip.legs[this.props.trip.legs.length - 1].setBusinessVolumeUnit({ value: 8, name: "Container Load"});
            this.props.trip.legs[this.props.trip.legs.length - 1].setBusinessVolumeValue(this.state.trip.noOfContainers || 1);
        }
        this.setState({
            legs: this.props.trip.legs
        });
   }

   selectLegType = (index, legType, legTypeName) => {
      if (this.viewMode) {
         return;
      }
      this.legs[index].setLegType(legType, legTypeName);
      this.setState({
         legs: this.legs
      })
   }

   selectCostType = (index, legCostType, legCostName, legCostSymbol) => {
      if (this.viewMode) {
         return;
      }
      if (this.props.multiLevelMovementType !== 2) {
         this.legs[0].setLegType(1, "Door to Door")
      }
      this.legs[index].selectCostType(legCostType, legCostName, legCostSymbol);
      this.setState({
         legs: this.legs
      })
   }

   onChange = (index, e) => {
      if (this.viewMode) {
         return;
      }
      const name = e.target.name;
      const value = e.target.value;

      this.legs[index]['set' + name.substr(0, 1).toUpperCase() + name.slice(1)](value, this.props.rfqServiceType);
      this.setState({
         legs: this.legs
      });
   }

   onChangeBudget = (index, e) => {
      const { rfqType, currencyDetails, trip } = this.props;
      const currencyType = (this.legs[index].legCostName !== 'INR') ? this.legs[index].legCostName : trip.priceInBaseCurrency;
      const conversionUSDObj = currencyDetails.find(currencyObj => currencyObj.name === (currencyType === 'EUR' ? 'EUR to INR' : 'USD to INR'));
      if (this.viewMode) {
         return;
      }
      const { value, name } = e.target;
      if(name === 'legBudgetINR') {
         this.legs[index].setBudget(value);
         this.legs[index].setBudgetINR(value);
         this.legs[index].setBudgetUSD( value && conversionUSDObj && ((value / conversionUSDObj.rupee).toFixed(5)) || value, currencyType === 'EUR');
      } else if((['legBudgetUSD', 'legBudgetSecondary'].includes(name))) {
         this.legs[index].setBudget(value && conversionUSDObj && ((value * conversionUSDObj.rupee).toFixed(5)) || value);
         this.legs[index].setBudgetINR(value && conversionUSDObj && ((value * conversionUSDObj.rupee).toFixed(5)) || value);
         this.legs[index].setBudgetUSD(value, currencyType === 'EUR');
      } else {
         this.legs[index].setBudget(value);
      }
      this.setState({
         legs: this.legs
      });
   }

   onChangeBudgetCP = (index, e) => {
      const { rfqType, currencyDetails, trip, rfqServiceType} = this.props;
      const currencyType = (this.legs[index].legCostName !== 'INR') ? this.legs[index].legCostName : trip.priceInBaseCurrency;;
      const conversionUSDObj = currencyDetails.find(currencyObj => currencyObj.name === (currencyType === 'EUR' ? 'EUR to INR' : 'USD to INR'));
      if (this.viewMode) {
         return;
      }
      const { value, name } = e.target;
      if(name === 'legBudgetCPINR') {
         this.legs[index].setBudgetCP(value, rfqServiceType);
         this.legs[index].setBudgetCPINR(value, rfqServiceType);
         this.legs[index].setBudgetCPUSD( value && conversionUSDObj && ((value / conversionUSDObj.rupee).toFixed(5)) || value, currencyType === 'EUR', rfqServiceType);
      } else if(['legBudgetCPUSD', 'legBudgetCPSecondary'].includes(name)) {
         this.legs[index].setBudgetCP(value && conversionUSDObj && ((value * conversionUSDObj.rupee).toFixed(5)) || value, rfqServiceType);
         this.legs[index].setBudgetCPINR(value && conversionUSDObj && ((value * conversionUSDObj.rupee).toFixed(5)) || value, rfqServiceType);
         this.legs[index].setBudgetCPUSD(value, currencyType === 'EUR', rfqServiceType);
      } else {
         this.legs[index].setBudgetCP(value);
      }
      this.setState({
         legs: this.legs
      });
   }

   onSelect = (index, value, name) => {
      if (this.viewMode) {
         return;
      }

      if(value.name ==="Select days/hrs"){
         alert("Please select Day or Hours");
         return
      }

      this.legs[index]['set' + name.substr(0, 1).toUpperCase() + name.slice(1)](value);
      this.setState({
         legs: this.legs
      });
   }

   onHCChange = (index, hcIndex, value, name, option = {}) => {
      const { rfqType, currencyDetails, trip, rfqServiceType } = this.props;
      let newHeadingCharge = this.legs[index]['multiModeHeadingCharges'];
      const legCurrencyType = newHeadingCharge[hcIndex].headingChargesUnitName;
      const currencyType = (legCurrencyType === "INR" ||  !legCurrencyType) ? ((this.legs[index].legCostName === 'INR' || !this.legs[index].legCostName) ? trip.priceInBaseCurrency : this.legs[index].legCostName ) : legCurrencyType;
      const conversionUSDObj = currencyDetails.find(currencyObj => currencyObj.name === (currencyType === 'EUR' ? 'EUR to INR' : 'USD to INR'));
      if (this.viewMode) {
         return;
      }
      newHeadingCharge[hcIndex][name] = value;
      if(name === 'headingChargesValue') {
         newHeadingCharge[hcIndex]['headingChargesID'] = option.id;
      }
      if(name === 'headingChargesUnit') {
         newHeadingCharge[hcIndex]['headingChargesUnitName'] = option.currency_name;
         newHeadingCharge[hcIndex]['headingChargesUnitSymbol'] = option.currency_symbol;
      }
      if((name === 'headingChargesBudget_inr' || name === 'headingChargesCp_inr')) {
         newHeadingCharge[hcIndex][name === 'headingChargesCp_inr' ? 'headingChargesCp' : 'headingChargesBudget'] = value;
         newHeadingCharge[hcIndex][name === 'headingChargesCp_inr' ? (currencyType === 'EUR' ? 'headingChargesCp_secondary' :'headingChargesCp_usd') : (currencyType === 'EUR' ? 'headingChargesBudget_secondary' :'headingChargesBudget_usd')] = value && conversionUSDObj && (value / conversionUSDObj.rupee).toFixed(5) || value;

      } else if((['headingChargesBudget_usd','headingChargesBudget_secondary','headingChargesCp_secondary','headingChargesCp_usd'].includes(name))) {
         newHeadingCharge[hcIndex][['headingChargesCp_usd', 'headingChargesCp_secondary'].includes(name) ? 'headingChargesCp' : 'headingChargesBudget'] = value && conversionUSDObj && (value * conversionUSDObj.rupee).toFixed(5) || value;
         newHeadingCharge[hcIndex][['headingChargesCp_usd', 'headingChargesCp_secondary'].includes(name) ? 'headingChargesCp_inr' : 'headingChargesBudget_inr'] = value && conversionUSDObj && (value * conversionUSDObj.rupee).toFixed(5) || value;
      } else if(name === 'headingChargesBusinessVolumeUnit') {
         newHeadingCharge[hcIndex]['headingChargesBusinessVolumeUnitName'] = option.name;
      }
        const headingCost = newHeadingCharge[hcIndex];
        const businessVolume = Number(headingCost['headingChargesBusinessVolumeValue'] || 0);
        if(businessVolume) {
        newHeadingCharge[hcIndex]['headingChargeVolumeCp_inr'] = headingCost['headingChargesCp_inr'] && (Number(headingCost['headingChargesCp_inr']) * businessVolume) || 0;
        newHeadingCharge[hcIndex]['headingChargeVolumeCp_usd'] = headingCost['headingChargesCp_usd'] && (Number(headingCost['headingChargesCp_usd']) * businessVolume) || 0;
        newHeadingCharge[hcIndex]['headingChargesVolumeCp_secondary'] = headingCost['headingChargesCp_secondary'] && (Number(headingCost['headingChargesCp_secondary']) * businessVolume) || 0;
        }
      this.legs[index]['multiModeHeadingCharges'] = newHeadingCharge;
      this.legs[index].updateMultiModeHeadingCharge(newHeadingCharge);
      if(newHeadingCharge[hcIndex]['headingChargesValue'] === 'Service Charges') {
         const hcCharges = newHeadingCharge[hcIndex];
         if(name === 'headingChargesCp_inr') {
            value = (value * (hcCharges['headingChargesBusinessVolumeUnit'] == 20 ? 1 : hcCharges['headingChargesBusinessVolumeValue']));
            this.legs[index].setBudgetCP(value, rfqServiceType);
            this.legs[index].setBudgetCPINR(value, rfqServiceType);
            this.legs[index].setBudgetCPUSD( value && conversionUSDObj && ((value / conversionUSDObj.rupee).toFixed(5)) || value, currencyType === 'EUR', rfqServiceType);
         } else if(name === 'headingChargesBudget_inr') {
            this.legs[index].setBudget(value);
            this.legs[index].setBudgetINR(value);
            this.legs[index].setBudgetUSD( value && conversionUSDObj && ((value / conversionUSDObj.rupee).toFixed(5)) || value, currencyType === 'EUR');
         }else if(['headingChargesCp_secondary', 'headingChargesCp_usd'].includes(name)) {
            value = (value * (hcCharges['headingChargesBusinessVolumeUnit'] == 20 ? 1 : hcCharges['headingChargesBusinessVolumeValue']));
            this.legs[index].setBudgetCP(value && conversionUSDObj && ((value * conversionUSDObj.rupee).toFixed(5)) || value, rfqServiceType);
            this.legs[index].setBudgetCPINR(value && conversionUSDObj && ((value * conversionUSDObj.rupee).toFixed(5)) || value, rfqServiceType);
            this.legs[index].setBudgetCPUSD(value, currencyType === 'EUR', rfqServiceType);
         } else if(['headingChargesBudget_usd', 'headingChargesBudget_secondary'].includes(name)) {
            this.legs[index].setBudget(value && conversionUSDObj && ((value * conversionUSDObj.rupee).toFixed(5)) || value);
            this.legs[index].setBudgetINR(value && conversionUSDObj && ((value * conversionUSDObj.rupee).toFixed(5)) || value);
            this.legs[index].setBudgetUSD(value, currencyType === 'EUR');
         }  else if(name === 'headingChargesBusinessVolumeValue') {
            this.legs[index].setBusinessVolumeValue(value);
            const price = (hcCharges['headingChargesCp_inr'] * (hcCharges['headingChargesBusinessVolumeUnit'] == 20 ? 1 : hcCharges['headingChargesBusinessVolumeValue']));
            this.legs[index].setBudgetCP(price, rfqServiceType);
            this.legs[index].setBudgetCPINR(price, rfqServiceType);
            this.legs[index].setBudgetCPUSD(price && conversionUSDObj && ((price / conversionUSDObj.rupee).toFixed(5)) || price, currencyType === 'EUR', rfqServiceType);
         } else if(name === 'headingChargesBusinessVolumeUnit') {
            this.legs[index].setBusinessVolumeUnit(option);
            const price = (hcCharges['headingChargesCp_inr'] * (hcCharges['headingChargesBusinessVolumeUnit'] == 20 ? 1 : hcCharges['headingChargesBusinessVolumeValue']));
            this.legs[index].setBudgetCP(price, rfqServiceType);
            this.legs[index].setBudgetCPINR(price, rfqServiceType);
            this.legs[index].setBudgetCPUSD(price && conversionUSDObj && ((price / conversionUSDObj.rupee).toFixed(5)) || price, currencyType === 'EUR', rfqServiceType);
         } else if(name === 'headingChargesUnit') {
            this.legs[index].selectCostType(option.currency_type, option.currency_name, option.currency_symbol);
         }
      }
      this.setState({
         legs: this.legs,
         isConfirmPopUp: false,
         legCurrencyDetails: ''
      });
   }

   removeMultiModeHeadingCharge = (index, hcIndex) => {
      let newHeadingCharge = this.legs[index]['multiModeHeadingCharges']
      newHeadingCharge = newHeadingCharge.filter((item, index) => index !== hcIndex);
      this.legs[index]['multiModeHeadingCharges'] = newHeadingCharge;
      this.legs[index].updateMultiModeHeadingCharge(newHeadingCharge);
      this.setState({
         legs: this.legs
      });
   }

   removeLeg = (index) => {
      if (this.viewMode) {
         return;
      }
      this.trip.removeLeg(index);
      this.setState({
         legs: this.trip.legs
      });
   }
   checkLegExists = (arr, value) => {
      const found = arr.some(el => el.legType === value);
      if (!found)
         return true;
      return false;
   }
   render() {
      const { legs, legCurrencyDetails } = this.state;
      const {
         trip,
         businessVolumes,
         pricingBasis,
         multiLevelMovementType,
         rfqType,
         stopDetailsSubmitted,
         currencyTypes,
         rfqServiceType,
         baseCurrencySubmitted,
         rfq,
         costHeadList,
         portsList,
         isError
      } = this.props;
      const baseCurrencyTypes = currencyTypes || (currencyTypes || []).filter(ct => ct.currency_name !== 'INR');
      const isHikal = true;
      return (
         <div className='vehicleDetails costheads pb-20 ph-10 mt-20'>
                <div className='pt-20 flex mb-20'>
                    <StopIcon />
                    <div className='ml-10 header'>Location Details And Stops</div>
                </div>
				<div className={Cx("flex flex-center mb-10 mt-10")}>
                    <div className="mr-20 flex mb-5 input-height">
                        <sup class="danger-color ml-2 pr t-4">*</sup><label className="header mt-8 mr-5">Base Currency</label> 
                        <Dropdown
                            items={baseCurrencyTypes}
                            selectedItem={baseCurrencyTypes.find(costType => { return trip.priceInBaseCurrencyType === costType['currency_type'] })}
                            name="currency_name"
                            onSelect={this.selectBaseCurrency}
                            displayKey="currency_name"
                            className="flex-1 fs-14 wt-150"
                            label="Select"
                        />
                    </div> 
                {(isError && !trip.priceInBaseCurrency) && <span className ="error-color fs-14 fSemibold op-7 mt-10">Please Select the Base Currency</span> }
                </div>
              {
               legs.map((leg, index) => {
                   leg.legType=(multiLevelMovementType==1)?1:leg.legType;
                   leg.legTypeName=(multiLevelMovementType==1)?"Door to Door":leg.legTypeName;
                   const secondaryCurrency = (leg.legCostName === 'INR' || !leg.legCostName) ? trip.priceInBaseCurrency : leg.legCostName; 
                   const isDiffMultiLegCurrency = (leg.multiModeHeadingCharges || []).filter(mc => (mc.headingChargesUnitName && mc.headingChargesUnitName !== 'INR')).length > 0;
                  return (

                     <div key={leg.id} className={Cx("br-5 pl-10 pr-10 pt-20 pb-20 mb-20 border-status-bar", {
                        'pr': [15].includes(rfq.type) && multiLevelMovementType === 2
                     })}>
                        {[15].includes(rfq.type) && <>
                           {legs.length > 1 && <CloseIcon className="pa t--15 r--15 curP" onClick={this.removeLeg.bind(this, index)} />}
                           {multiLevelMovementType === 2 ? <div className="header-medium-color fBold fs-20 mb-10">Leg {index + 1}</div> : <div className="header-medium-color fBold fs-20 mb-10">Door To Door</div>}
                        </>}
                        <div className="flex flex-between mb-10">
                           <div className="col-2 mr-20">
                              <div className="fSemibold fs-14 header-medium-color mb-5 ml-5">From <sup className='error-color'>*</sup></div>
                              {!this.viewMode && <PlacesAutoComplete hasError={stopDetailsSubmitted && !leg.from.location} setLocation={this.setFromLocation.bind(this, index)} value={leg.from.location || ''} />}
                              {this.viewMode && <Input value={leg.from.location || ''} />}
                              {isError && !(leg.from.location) && <div className="error-color fs-14 fSemibold op-7 ml-5">Please enter the location</div>}
                           </div>
                           <div className="col-2">
                              <div className="fSemibold fs-14 header-medium-color mb-5 ml-5">{[15].includes(rfq.type) ? 'To' : 'Port'} <sup className='error-color'>*</sup></div>
                              {![15].includes(rfq.type) ? <Dropdown 
                                 items={portsList}
                                 selectedItem={leg.to.location && portsList.find(port => { return port.destination === leg.to.location })}
                                 name="destination"
                                 onSelect={this.setToLocation.bind(this, index)}
                                 displayKey="destination"
                                 label="Select"
                              /> :
                              <>
                                 {!this.viewMode && <PlacesAutoComplete hasError={stopDetailsSubmitted && !leg.to.location} setLocation={this.setToLocation.bind(this, index)} value={leg.to.location || ''} />}
                                 {this.viewMode && <Input value={leg.to.location || ''} />}
                              </>}
                              {isError && !(leg.to.location) && <div className="error-color fs-14 fSemibold op-7 ml-5">Please enter the port</div>}
                           </div>
                        </div>
                        <div className="flex mb-40">
                        {[15].includes(rfq.type) && <div className={Cx("mr-10", {
                              'wt-110': !isHikal,
                              'wt-180': isHikal
                           })}>
                              <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Leg Type</div>
                              {multiLevelMovementType === 2 ? <Dropdown
                                 items={((rfq.rfqDetails || {}).serviceCategoryType === 1 ? [...LEGS_TYPES_SEA] : [...LEGS_TYPES_AIR])}
                                 selectedItem={((rfq.rfqDetails || {}).serviceCategoryType === 1 ? [...LEGS_TYPES_SEA] : [...LEGS_TYPES_AIR]).find(val => { return leg.legType === val.value })}
                                 name="legType"
                                 onSelect={(e) => this.selectLegType(index, e.value, e.name)}
                                 displayKey="name"
                                 className="flex-1 fs-14"
                                 label="Select"
                              /> :
                                 <Input
                                    value="Door To Door"
                                    // onChange={() => this.selectCostType(0, 1, "Door to Door")}
                                    disabled="disabled"
                                 />
                              }
                           </div>}
                           <div className="wt-80 mr-10">
                              <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">Currency</div>
                              <Dropdown
                                 items={currencyTypes}
											selectedItem={currencyTypes.find(costType => { return leg.legCostName === costType['currency_name'] })}
                                 name="currency_name"
                                 onSelect={(e) => this.selectCostType(index, e['currency_type'], e['currency_name'], e['currency_symbol'])}
                                 displayKey="currency_name"
                                 label="Select"
                                 className={Cx('flex-1 fs-14',{ 'disabled': !trip.priceInBaseCurrency})} 
                              />
                           </div>
                           <div className={Cx("mr-10 wt-150")}>
                              <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">TAT</div>
                              {/* <div className="wt-100p mb-30 flex"> */}
                              <div className="flex">
                                 <Input type="number" placeholder="TAT" value={leg.tatValue} onChange={this.onChange.bind(this, index)} name="tatValue" />
                                 <Dropdown
                                 items={[...TAT_UNITS]}
                                 selectedItem={TAT_UNITS.find(tatUnit => { return leg.tatUnit === tatUnit.value })}
                                 name="tatUnit"
                                 onSelect={this.onSelect.bind(this, index)}
                                 displayKey="name"
                                 className="flex-1 fs-14"
                                 label="---Select---"
                              />
                              </div>
                              </div>
								<div className="wt-140 mr-10">
										<div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">{`${((rfq.rfqDetails || {}).serviceCategoryType === 1 && (rfq.rfqDetails || {}).serviceType == 4 ) ? 'Container Shipment' : 'Storage Free Days'}`}</div>
										<div className="flex">
                                        <Input type="number" placeholder="" value={leg.containerFree} onChange={this.onChange.bind(this, index)} name="containerFree" />
                                        <Dropdown
                                            items={[...TAT_UNITS]}
                                            selectedItem={TAT_UNITS.find(tatUnit => { return leg.eximTatUnit === tatUnit.value })}
                                            name="eximTatUnit"
                                            onSelect={this.onSelect.bind(this, index)}
                                            displayKey="name"
                                            className="flex-1 fs-14"
                                            label="---Select---"
                                        />
                                    </div>
									</div>
                           <div className={Cx("mr-10 wt-150")}>
                              <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">{'Business Volume'}</div>
                              <div className=""><Input type="number" placeholder="BV" value={leg.businessVolumeValue} onChange={this.onChange.bind(this, index)} name="businessVolumeValue" readOnly={((rfq.rfqDetails || {}).serviceCategoryType === 2 || (rfq.rfqDetails || {}).serviceType == 5)}/></div>
                           </div>

                           <div className={Cx("wt-110 mr-10 wt-180")}>
                              <div className="fBold fs-14 header-medium-color mb-5 ml-5 ht-20">UOM</div>
                              <Dropdown
                                 items={businessVolumes}
                                 selectedItem={businessVolumes.find(businessVolumeUnit => { return leg.businessVolumeUnit === businessVolumeUnit.value })}
                                 name="businessVolumeUnit"
                                 onSelect={this.onSelect.bind(this, index)}
                                 displayKey="name"
                                 label="---Select---"
                                 className={Cx('flex-1 fs-14', { 'disabled': ((rfq.rfqDetails || {}).serviceCategoryType === 2 || (rfq.rfqDetails || {}).serviceType == 5)})} 
                              />
                           </div>
                        </div>
                        <div className="wt-100p  flex">
                           <div className={Cx("fBold fs-14 header-medium-color mb-5 ml-5", {'wt-110': !isHikal, 'wt-500': isHikal})}>Cost Heading</div>
							<div className="fBold fs-14 header-medium-color wt-80 pl-5 mr-15 ml-5">{"Currency"}</div>
                           <Fragment>
                              {<div className={Cx("fBold fs-14 header-medium-color ml-5", {'wt-110': !isHikal, 'wt-80': isHikal})}>Business Vol</div>}
                              <div className={Cx("fBold fs-14 header-medium-color ml-5",{'wt-110': !isHikal, 'wt-150': isHikal})}>UOM</div>
                           </Fragment>
                           <Fragment>
                              <div className="fBold fs-14 header-medium-color wt-110 ml-5">LPP</div>
                              <div className="fBold fs-14 header-medium-color wt-110 ml-5">LPP Date</div>
                           </Fragment>
                            <Fragment>
                                <div className="fBold fs-14 header-medium-color wt-110 ml-5">Budget (INR)</div>
                                {(isHikal ? isDiffMultiLegCurrency : true) && <div className="fBold fs-14 header-medium-color wt-110 ml-5">Budget {`(${trip.priceInBaseCurrency})`}</div>}
                            </Fragment> 
                            <Fragment>
                                <div className="fBold fs-14 header-medium-color wt-120 ml-10">Ceiling Price(INR)</div>
                                {(isHikal ? isDiffMultiLegCurrency : true) && <div className="fBold fs-14 header-medium-color wt-120 ml-10">Ceiling Price {`(${trip.priceInBaseCurrency})`}</div>}
                            </Fragment>
                           <div className="fBold fs-14 header-medium-color wt-110 ml-10"></div>
                        </div>
                        {
                           leg.multiModeHeadingCharges.length > 0 ? leg.multiModeHeadingCharges.map((hc, hcindex) => {

                              const hcSecondaryCurrency = (hc.headingChargesUnitName === "INR" || !hc.headingChargesUnitName) ? secondaryCurrency : hc.headingChargesUnitName;
                              return(
                              <div key={`hc_${hcindex}`} className={Cx("flex mb-10", {'ht-40': !isHikal})}>
                                 <div className={Cx("mr-10", {'wt-110': !isHikal, 'wt-500': isHikal})}>
                                    {/* <div className="wt-100p mb-30 flex"> */}
                                    {(isHikal ? hc.headingChargesValue : true) ? <div className="">
                                       <Input placeholder="Charges" readOnly={isHikal} value={hc.headingChargesValue} onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} name="headingChargesValue" />
                                    </div> : 
                                       <Dropdown
                                       items={costHeadList}
                                       selectedItem={costHeadList.find(costHead => { return hc.headingChargesValue === costHead.name })}
                                       name="headingChargesValue"
                                       onSelect={(e) => this.onHCChange(index, hcindex, e.name, 'headingChargesValue', e)}
                                       displayKey="name"
                                       className="flex-1"
                                       label="Select.."
                                       /> 
                                    }
                                    {/* <Dropdown
                                                        items={pricingBasis}
                                                        selectedItem={pricingBasis.find(pricingBasis => { return hc.headingChargesUnit === pricingBasis.value })}
                                                        name="headingChargesUnit"
                                                        onSelect={(e) => this.onHCChange(index, hcindex, e.value, 'headingChargesUnit')}
                                                        displayKey="name"
                                                        className="flex-1"
                                                        label="Select unit"
                                                    /> */}

                                    {/* </div> */}
                                    { isHikal && baseCurrencySubmitted && !hc.headingChargesValue && <span className ="error-color fs-14 fSemibold op-7 mt-10">Please Select the Cost</span> }
                                 </div>
                                 <div className="wt-80 mr-10">
                                    <Dropdown
                                       items={currencyTypes}
                                       selectedItem={currencyTypes.find(pricingBasis => { return hc.headingChargesUnit === pricingBasis['currency_type'] })}
                                       name="headingChargesUnit"
                                       onSelect={(e) => {
                                            this.setState({
                                                isConfirmPopUp: true,
                                                legCurrencyDetails: {
                                                    index,
                                                    hcindex,
                                                    currency: e
                                                }
                                            })
                                       }}
                                       displayKey="currency_name"
                                       label="Select"
                                       className={Cx('flex-1 fs-14', { 'disabled': !trip.priceInBaseCurrency})}
                                    />
                                    {isHikal && baseCurrencySubmitted && !hc.headingChargesUnit && <span className ="error-color fs-14 fSemibold op-7 mt-10">Please Select the Currency</span> }
                                 </div> 
                                    <Fragment>
                                       {<div className={Cx("mr-10", {'wt-110': !isHikal, 'wt-80': isHikal})}>
                                          <div className="wt-100p mr-20"><Input type="number" placeholder="Business Vol" value={hc.headingChargesBusinessVolumeValue} onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} name="headingChargesBusinessVolumeValue" /></div>
                                       </div>}
                                       <div className={Cx("mr-10", {'wt-110': !isHikal, 'wt-150': isHikal})}>
                                       <Dropdown
                                          items={businessVolumes}
                                          selectedItem={businessVolumes.find(businessVolumeUnit => { return hc.headingChargesBusinessVolumeUnit === businessVolumeUnit.value })}
                                          name="headingChargesBusinessVolumeUnit"
                                          onSelect={(e) => this.onHCChange(index, hcindex, e['value'], 'headingChargesBusinessVolumeUnit', e)}
                                          displayKey="name"
                                          className="flex-1 fs-14"
                                          label="Select"
                                       />
                                       </div>
                                    </Fragment>
                                    <Fragment>
                                       <div className="wt-110 mr-10">
                                          <div className="wt-100p mr-20">
                                             <Input 
                                                type="number" 
                                                placeholder="" 
                                                value={hc.headingChargesLPP} 
                                                onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} 
                                                name="headingChargesLPP" 
                                                disabled={true}
                                             />
                                          </div>
                                       </div>
                                       <div className="wt-110 mr-10">
                                          <div className="wt-100p mr-20">
                                             <Input 
                                                placeholder="" 
                                                value={hc.headingChargesLPPDate} 
                                                onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} 
                                                name="headingChargesLPPDate" 
                                                disabled={true}
                                             />
                                          </div>
                                       </div>
                                    </Fragment>
                                 <Fragment>
                                    <div className="wt-110 mr-10">
                                       <div className="wt-100p mr-20"><Input type="number" className={Cx({ 'disabled': [2, 3].includes(hc.headingChargesUnit) || !hc.headingChargesUnit })} readOnly={[2, 3].includes(hc.headingChargesUnit)} placeholder="INR" value={hc.headingChargesBudget_inr && ([2, 3].includes(hc.headingChargesUnit)) && Number(hc.headingChargesBudget_inr).toFixed(2) || hc.headingChargesBudget_inr } onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} name="headingChargesBudget_inr" onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}/></div>
                                    </div>
                                    {(isHikal ? isDiffMultiLegCurrency : true) && <div className="wt-110 mr-10">
                                       <div className="wt-100p mr-20">
                                          <Input 
                                             type="number" 
                                             className={Cx({ 'disabled': hc.headingChargesUnit === 1 || !hc.headingChargesUnit })} 
                                             readOnly={hc.headingChargesUnit === 1} 
                                             placeholder={'10' || hcSecondaryCurrency} 
                                             value={hc[`headingChargesBudget_${hcSecondaryCurrency === 'EUR' ? 'secondary' : 'usd'}`] && (hc.headingChargesUnit === 1) && Number(hc[`headingChargesBudget_${hcSecondaryCurrency === 'EUR' ? 'secondary' : 'usd'}`]).toFixed(2) || (hc[`headingChargesBudget_${hcSecondaryCurrency === 'EUR' ? 'secondary' : 'usd'}`]) } 
                                             onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} 
                                             name={hcSecondaryCurrency === 'EUR' ? "headingChargesBudget_secondary" : "headingChargesBudget_usd"} 
                                             onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}
                                          />
                                       </div>
                                    </div>}
                                 </Fragment>
                                 <Fragment>
                                    <div className="wt-120 mr-10">
                                       <div className="wt-100p mr-20"><Input type="number" className={Cx({ 'disabled': [2,3].includes(hc.headingChargesUnit) || !hc.headingChargesUnit })} placeholder="INR" readOnly={[2,3].includes(hc.headingChargesUnit)} value={hc.headingChargesCp_inr && ([2,3].includes(hc.headingChargesUnit)) && Number(hc.headingChargesCp_inr).toFixed(2) || hc.headingChargesCp_inr } onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} name="headingChargesCp_inr" onKeyDown={e => (["e", "E", "+", "-"].includes(e.key)) && e.preventDefault()}/></div>
                                    </div>
                                    {(isHikal ? isDiffMultiLegCurrency : true) && <div className="wt-120 mr-10">
                                       <div className="wt-100p mr-20">
                                          <Input 
                                             type="number" 
                                             className={Cx({ 'disabled': hc.headingChargesUnit === 1 || !hc.headingChargesUnit })} 
                                             placeholder={'12' || hcSecondaryCurrency} 
                                             readOnly={hc.headingChargesUnit === 1} 
                                             value={hc[`headingChargesCp_${hcSecondaryCurrency === 'EUR' ? 'secondary' : 'usd'}`] && (hc.headingChargesUnit === 1) && Number(hc[`headingChargesCp_${hcSecondaryCurrency === 'EUR' ? 'secondary' : 'usd'}`]).toFixed(2) || (hc[`headingChargesCp_${hcSecondaryCurrency === 'EUR' ? 'secondary' : 'usd'}`]) } 
                                             onChange={(e) => this.onHCChange(index, hcindex, e.target.value, e.target.name)} 
                                             name={hcSecondaryCurrency === 'EUR' ? 'headingChargesCp_secondary' : 'headingChargesCp_usd'} 
                                          />
                                       </div>
                                    </div>}
                                 </Fragment>
                                 <div className="wt-110 flex mr-10">
                                    {
                                       leg.multiModeHeadingCharges.length > 1 && (isHikal ? hc.headingChargesValue !== 'Service Charges' : true) ? <div className="flex flex-middle flex-center wt-25 ht-25 br-20 border-none br-50p mr-5">
                                          <CloseIcon onClick={() => this.removeMultiModeHeadingCharge(index, hcindex)} className="wt-28 white-color ht-28 pa curP" />
                                       </div> : ''
                                    }
                                    {
                                       hcindex == leg.multiModeHeadingCharges.length - 1 ? <div className="flex flex-middle flex-center bg-theme wt-25 ht-25 br-20 border-none br-50p mr-5">
                                          <PlusIcon onClick={() => this.addNewHeadingCharge(index, 'add')} className="wt-15 ht-15" />
                                       </div> : ''
                                    }
                                 </div>
                              </div>)
                           }) : this.addNewHeadingCharge(index)
                        }
                     </div>
                  )
               })
            }
            {
               [15].includes(rfq.type) && multiLevelMovementType === 2 &&
               <div className="flex flex-middle curP mt-30 wt-max-content" onClick={this.addLeg}>
                  <div className="flex flex-middle flex-center bg-theme wt-25 ht-25 br-20 border-none br-50p mr-5">
                     <PlusIcon className="wt-15 ht-15" />
                  </div>
                  <div className="fSemibold fs-16 fBold header-dark-color">Add Leg</div>
               </div>
            }
            {this.state.isConfirmPopUp &&
               <ConfirmationPopup 
               text={"Are you sure to change the currency type ?"}
               onCancel={() => this.setState({ isConfirmPopUp: false, legCurrencyDetails: ''})}
               onConfirm={() => this.onHCChange(legCurrencyDetails.index, legCurrencyDetails.hcindex, legCurrencyDetails.currency['currency_type'], 'headingChargesUnit', legCurrencyDetails.currency)}
            />
            }

         </div>

      )
   }
}

export default LegDetails;
